import { render, staticRenderFns } from "./ColorSidebar.vue?vue&type=template&id=57fe2320"
import script from "./ColorSidebar.vue?vue&type=script&lang=js"
export * from "./ColorSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports